/** In-app notifications (ADR-0046): the bell in every interface's top bar. */
export const enNotifications = {
  'notifications.title': 'Notifications',
  'notifications.open': 'Notifications',
  'notifications.openUnread': 'Notifications, {count} unread',
  'notifications.markAllRead': 'Mark all as read',
  'notifications.empty':
    'Nothing new. Approvals, deliveries and requests that need you appear here.',
  'notifications.loadError': 'Notifications could not be loaded.',
  'notifications.unreadDot': 'Unread',
  'notifications.otherBranch': 'Opens in {branch}',
  'notifications.kind.approval.pending': '{label} is waiting for your approval ({step}, {amount}).',
  'notifications.kind.approval.approved': '{label} was approved.',
  'notifications.kind.approval.rejected': '{label} was rejected.',
  'notifications.kind.receipt.posted': 'Goods for {po} were received ({gr}).',
  'notifications.kind.receipt.exceptions': '{gr} has items held for checking (lines: {count}).',
  'notifications.kind.receipt.emergency_review': 'Emergency purchase {gr} needs your review.',
  'notifications.kind.requisition.pending_approval':
    'Stock request {number} is waiting for your approval.',
  'notifications.kind.requisition.ready_to_pick':
    'Stock request {number} is approved and ready to pick.',
  'notifications.kind.requisition.rejected': 'Your stock request {number} was rejected.',
  'notifications.kind.requisition.issued':
    'Your stock request {number} was issued. Confirm when it arrives.',
  'notifications.kind.stock.low': 'Items below their reorder point: {count}.',
  'notifications.kind.ap.due':
    'Supplier invoices overdue: {overdue}; due within {days} days: {dueSoon}.',
} as const;
